import { render, staticRenderFns } from "./organizationalRange.vue?vue&type=template&id=53746a22&scoped=true"
import script from "./organizationalRange.vue?vue&type=script&lang=js"
export * from "./organizationalRange.vue?vue&type=script&lang=js"
import style0 from "./organizationalRange.vue?vue&type=style&index=0&id=53746a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53746a22",
  null
  
)

export default component.exports